import React from "react";
import { useState } from "react";

import { Tooltip, TooltipProps } from "@mui/material";

import copy from "clipboard-copy";

interface ChildProps {
  copy: (content: any) => void;
}

export interface Props {
  TooltipProps?: Partial<TooltipProps>;
  children: (props: ChildProps) => React.ReactElement<any>;
}

interface OwnState {
  showTooltip: boolean;
}

const CopyToClipboard = ({ TooltipProps, children }: Props) => {
  const [state, setState] = useState<OwnState>({ showTooltip: false });

  const onCopy = (content: any) => {
    copy(content);
    setState({ showTooltip: true });
  };

  const handleOnTooltipClose = () => {
    setState({ showTooltip: false });
  };

  return (
    <Tooltip
      open={state.showTooltip}
      title={"Copied to clipboard!"}
      leaveDelay={1500}
      onClose={handleOnTooltipClose}
      {...(TooltipProps || {})}>
      {children({ copy: onCopy }) as React.ReactElement<any>}
    </Tooltip>
  );
};

export default CopyToClipboard;
